import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c857071"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-title px-2 mt-3 fs-5" }
const _hoisted_2 = { class: "card-text" }
const _hoisted_3 = {
  style: {"font-size":"14px"},
  class: "my-3"
}
const _hoisted_4 = { class: "card-text" }
const _hoisted_5 = { class: "d-flex" }

import { computed, reactive, ref } from "vue";
import dayjs from "dayjs";
import { useRouter } from "vue-router";
import { MessageDialog } from "../../../../framework/frontend/MessageDialog";
import { UserBlockContents } from "../../../../server/dto/generated/UserBlockContents";
import { BlocklyService } from "../../../biz/remote/BlocklyService";
import { IdentifyFactory } from "../../../utils/IdentifyFactory";
import { SessionUser } from "../../../utils/SessionUser";
import { DT_FORMAT } from "../../../../framework/util/momentExtends";
import { translation } from "../../../lang/Translation";
import TitleEdit from "../../../components/project/TitleEdit.vue";
import { AuthUser } from "../../../../server/dto/AuthUser";

interface Prop {
  item: UserBlockContents;
  class: any;
  onReload: () => void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ClassCardItem',
  props: {
    item: null,
    class: null,
    onReload: null
  },
  setup(__props: any) {

const props = __props as {
  item: UserBlockContents;
  class: any;
  onReload: () => void;
};



const t = translation;
const item = reactive(props.item);
const router = useRouter();
const updataDt = computed(() => {
  return dayjs(item.update_dt).format(DT_FORMAT);
});

/**
 * 動的ラベル
 */
// ユーザーのプロジェクト保存時の画像
console.log("contents", item)
const imagePath = `./assets/${item.user_id}/project/${item.project_id}.png`;

/**
 * サーバー上のプロジェクトをコピー
 */
const click_copy = async (item: UserBlockContents, event: Event) => {
  event.stopPropagation();
  const project_id = item.project_id;
  if (
    confirm(
      `id[ ${project_id} ] ${t.to(
        "このプロジェクトをコピーします。よろしいですか？",
        "list_confirm_copy"
      )} `
    )
  ) {
    const biz = new BlocklyService();
    await biz.duplicate(
      project_id,
      SessionUser.instance.userId,
      IdentifyFactory.instance.getUniqueStr()
    );
    MessageDialog.info(t.to("コピーしました", "copied"));
    props.onReload();
  }
};

/**
 * サーバー上のプロジェクトを削除
 */
const click_delete = async (item: UserBlockContents, event: Event) => {
  event.stopPropagation();

  const project_id = item.project_id;
  if (item.is_publish === 1 || item.is_group_publish) {
    MessageDialog.error(
      t.to("リンクしているプロジェクトは削除できません", "liked_can_not_delete")
    );
    return;
  }

  if (
    confirm(
      `id[ ${project_id} ] ${t.to(
        "このプロジェクトを削除します。よろしいですか？",
        "list_confirm_delete"
      )}`
    )
  ) {
    const biz = new BlocklyService();
    await biz.deleteProject(project_id, SessionUser.instance.userId);
    props.onReload();
  }
};

// プロジェクト選択
const selectRow = () => {
  router.push("/blockly/" + item.project_id);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["gx-3 w-100 p-1 border-light card", { member_item: item.member_id !== _unref(AuthUser).NO_CLASS_MEMBER }])
  }, [
    _createElementVNode("img", {
      class: "w-100 img-responsive",
      src: imagePath,
      onerror: "this.src='./public/list_back_noimage.png'",
      lazyload: "",
      onClick: selectRow
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TitleEdit, {
        project_id: item.project_id,
        title: item.title
      }, null, 8, ["project_id", "title"])
    ]),
    _createElementVNode("div", {
      class: "card-body",
      onClick: selectRow
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, "ID : " + _toDisplayString(item.project_id), 1),
          _createElementVNode("div", null, _toDisplayString(_unref(updataDt)), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "btn btn-primary w-50 me-2",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (click_copy(item, $event)))
            }, _toDisplayString(_unref(t).to("コピー", "list_copy")), 1),
            _createElementVNode("button", {
              class: "btn btn-danger w-50",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (click_delete(item, $event)))
            }, _toDisplayString(_unref(t).to("削除", "list_del")), 1)
          ])
        ])
      ])
    ])
  ], 2))
}
}

})